import { clientEnv } from '@/shared/config/env';
import { activeSkinModule, isGc987Skin, isLorUsSkin, isOroMxSkin } from '@/shared/theme/active-skin';
import { gc987ThemeTokenUrl } from '@/shared/theme/gc987-h5-skin';
import { lorUsThemeTokenUrl } from '@/shared/theme/lor-us-h5-skin';
import { oroMxThemeTokenUrl } from '@/shared/theme/oro-mx-h5-skin';
import type { BootstrapResponse } from './types';

const mockSiteId = clientEnv.siteId;

// B-lite 皮肤模块自带 mock 租户；旧皮肤分支原样保留。
const mockTenant = activeSkinModule
  ? activeSkinModule.mockTenant
  : isOroMxSkin
  ? {
      brandId: 'orocasino',
      countryCode: 'MX',
      currency: 'MXN',
      defaultLanguage: 'es-MX',
      layoutTemplateId: 'oro-mx-h5-home',
      licenseTextKey: 'compliance.license.mx',
      minAge: 18,
      paymentType: 'card',
      pixDeposit: false,
      runtimeVersion: 'r-oro-mx-local',
      supportedLanguages: ['es-MX', 'en-US', 'zh-CN', 'zh-TW'],
      themeTokenUrl: oroMxThemeTokenUrl,
      themeVersion: 'oro-mx-h5',
    }
  : isLorUsSkin
    ? {
        brandId: 'lordofriches',
        countryCode: 'US',
        currency: 'USD',
        defaultLanguage: 'en-US',
        layoutTemplateId: 'lor-us-h5-home',
        licenseTextKey: 'compliance.license.us',
        minAge: 21,
        paymentType: 'card',
        pixDeposit: false,
        runtimeVersion: 'r-lor-us-local',
        supportedLanguages: ['en-US'],
        themeTokenUrl: lorUsThemeTokenUrl,
        themeVersion: 'lor-us-h5',
      }
    : isGc987Skin
      ? {
          brandId: 'gc987',
          countryCode: 'BR',
          currency: 'BRL',
          defaultLanguage: 'pt-BR',
          layoutTemplateId: 'gc987-h5-home',
          licenseTextKey: 'compliance.license.br',
          minAge: 18,
          paymentType: 'pix',
          pixDeposit: true,
          runtimeVersion: 'r-gc987-local',
          supportedLanguages: ['pt-BR', 'en-US'],
          themeTokenUrl: gc987ThemeTokenUrl,
          themeVersion: 'gc987-h5',
        }
      : {
          brandId: 'verdebet',
          countryCode: 'BR',
          currency: 'BRL',
          defaultLanguage: 'pt-BR',
          layoutTemplateId: 'mobile-verde-home',
          licenseTextKey: 'compliance.license.br',
          minAge: 18,
          paymentType: 'pix',
          pixDeposit: true,
          runtimeVersion: 'r-local',
          supportedLanguages: ['pt-BR', 'en-US'],
          themeTokenUrl: '',
          themeVersion: 't-local',
        };

export const mockBootstrap: BootstrapResponse = {
  assets: {
    assetManifestUrl: activeSkinModule
      ? ''
      : isOroMxSkin
      ? `${oroMxThemeTokenUrl.replace(/theme-tokens\.json$/, 'asset-manifest.json')}`
      : isLorUsSkin
        ? '/skins/lor-us-h5/asset-manifest.json'
        : '',
    themeTokenUrl: mockTenant.themeTokenUrl,
    translationUrl: '',
  },
  brandId: mockTenant.brandId,
  componentRegistry: {
    activityTypes: [
      {
        displayComponent: 'ActivityWelcomeBonusCard',
        minClientBuild: '0.1.0',
        requiredI18nKeys: ['activity.welcome.title'],
        requiredSlots: ['activity_terms_link'],
        schemaVersion: 1,
        type: 'welcome_bonus',
      },
    ],
    gameTypes: [
      {
        displayComponent: isLorUsSkin ? 'LorUsGameCard' : 'GameCardSlot',
        minClientBuild: '0.1.0',
        schemaVersion: 1,
        type: 'slot',
      },
      {
        displayComponent: 'GameCardLiveCasino',
        minClientBuild: '0.1.0',
        schemaVersion: 1,
        type: 'live_casino',
      },
    ],
    paymentMethods: [
      {
        displayComponent: mockTenant.pixDeposit ? 'PixDepositPanel' : 'CardDepositPanel',
        minClientBuild: '0.1.0',
        schemaVersion: 1,
        type: mockTenant.paymentType,
      },
    ],
  },
  compliance: {
    kycRequiredForWithdrawal: true,
    licenseTextKey: mockTenant.licenseTextKey,
    minAge: mockTenant.minAge,
    responsibleGamingKey: 'compliance.responsibleGaming.entry',
  },
  contentBundleVersion: 'c-local',
  countryCode: mockTenant.countryCode,
  currency: mockTenant.currency,
  defaultLanguage: mockTenant.defaultLanguage,
  features: {
    kyc: true,
    pixDeposit: mockTenant.pixDeposit,
    responsibleGaming: true,
    sportsbook: false,
    withdrawal: true,
  },
  layoutTemplate: {
    layoutTemplateId: mockTenant.layoutTemplateId,
    layoutTemplateVersion: 'lt-local',
    requiredSlots: isLorUsSkin
      ? ['wallet_summary', 'responsible_gaming_entry', 'payment_entry']
      : [
          'compliance_strip',
          'wallet_summary',
          'responsible_gaming_entry',
          'payment_entry',
        ],
  },
  layoutTemplateVersion: 'lt-local',
  minClientBuild: '0.1.0',
  runtimeVersion: mockTenant.runtimeVersion,
  schemaVersion: 1,
  siteId: mockSiteId,
  supportedLanguages: mockTenant.supportedLanguages,
  themeVersion: mockTenant.themeVersion,
  translationBundleVersion: 'i18n-local',
};
